<template>
    <div>
        <el-tabs v-model="cur" @tab-click="handleClick">
            <el-tab-pane label="个人信息" name="1">
                <userinfo @refr="refreshs"></userinfo>
            </el-tab-pane>
            <el-tab-pane label="账号安全" name="2">
                <account></account>
            </el-tab-pane>
            <el-tab-pane label="个人资料" name="3">
                <myinfo></myinfo>
            </el-tab-pane>
            <!-- <el-tab-pane label="简历附件" name="4">
                <jl></jl>
            </el-tab-pane> -->
        </el-tabs>
    </div>
</template>
<script>
    import {
        myCollection
    } from "@/api/index.js"
    import userinfo from './userinfo.vue'
    import account from './account.vue'
    import myinfo from './myinfo.vue'
    import jl from './myjl.vue'
    export default {
        name: 'Setting',
        components: {
            userinfo,
            account,
            myinfo,
            jl
        },
        props:['type'],
        data() {
            return {
                cur: "1",
            }
        },
        mounted() {
            if(this.type){
                this.cur = this.type+''
            }else{
                this.cur = '1'
            }
            
        },
        methods: {
            handleClick(e){
                console.log(1231313)
            },
            refreshs(){
                console.log("111")
                this.$emit("refresh")
            }
        }
    }
</script>

<style scoped>
    
</style>